import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import close from "../../assets/images/close.png";
import { useSelector, useDispatch } from "react-redux";
import plus from "../../assets/images/plus_icon.png";
import { Modal, ModalBody, Button, Form, Input, FormText, FormGroup, Label, Row, Col } from 'reactstrap';
import axiosInstance from '../../helpers/axios';
import { Box } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import MuiButton from '@mui/material/Button';

export default function AddInstitute({ onAddInstitute }) {
  const editstate = useSelector((state) => state.Editform?.res);
  const savedstate = useSelector((state) => state.Updateeditform?.res);
  const [formOpen, setFormOpen] = useState(false);
  const [instituteCode, setInstituteCode] = useState('');
  const [insLogo, setInstituteLogo] = useState('');
  const [insName, setInstituteName] = useState('');
  const [insEmail, setInstituteEmail] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [insAddress, setInstituteAddress] = useState('');
  const [notes, setNotes] = useState('');
  const [signatoryDesignation, setSignatoryDesignation] = useState('');
  const [signatoryName, setSignatoryName] = useState('');
  const [insCity, setInstituteCity] = useState('');
  const [insState, setInstituteState] = useState('');
  const [insPincode, setInstitutePincode] = useState('');
  const [number, setInstituteNumber] = useState('');
  const [insType, setInstituteType] = useState('');
  const [category, setCategory] = useState('');
  const [gstApplicableCheck, setGSTApplicableCheck] = useState(false);
  const [gstNumber, setGSTNumber] = useState('');
  const [enableNext, setEnableNext] = useState(false);
  const [fileEntries, setFileEntries] = useState([{ fileName: '', file: null, url: null }]);
  const [emails, setEmails] = useState([]);
  const [currentEmail, setCurrentEmail] = useState('');
  const [notifyDisbursements, setNotifyDisbursements] = useState(true);
  const [notifyRefunds, setNotifyRefunds] = useState(false);
  const [notifyT3Reminders, setNotifyT3Reminders] = useState(false);
  const [notifyBounces, setNotifyBounces] = useState(false);
  const [isSameAsInstitute, setIsSameAsInstitute] = useState(true);
  const [parentSearch, setParentSearch] = useState('');
  const [parentResults, setParentResults] = useState([]);
  const [selectedParentInstitute, setSelectedParentInstitute] = useState(null);
  const [partners, setPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState("");
  const [fundSource, setFundSource] = useState('');

  const dispatch = useDispatch();
  const location = useLocation();
  const user = null;

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const createInstituteBranchApi = async (payLoad) => {
    try {
      const response = await axiosInstance.post(`/institute-branches/info/create`, payLoad, {
        headers: {
        }
      });
    } catch (e) {
      console.error(e);
    }
  };

  const searchParentInstitute = async (value) => {
    if (!value || value.length < 3) {
      setParentResults([]);
      return;
    }
    try {
      const res = await axiosInstance.get(
        `/info/parent-name?name=${value}`,
        {
          headers: {
          },
        }
      );
      setParentResults(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const b2bsignupURL = "https://institute-apis.feemonk.com/auth/register";

  const callRegistration = () => {
    if (insLogo) {
      const file = new FormData();
      file.append('file', insLogo);
      file.append('type', "logo");
      axiosInstance.post(`/file/upload`, file)
        .then((res) => {
          const obj2 = {
            code: instituteCode,
            name: insName,
            email: insEmail,
            contact: number,
            logo: res.data.data.s3Url,
            address: insAddress,
            city: insCity,
            state: insState,
            gstApplicable: gstApplicableCheck,
            gstNumber: gstNumber,
            pincode: insPincode,
            salesOwner: 'string',
            website: 'string',
            mouFiles: JSON.stringify(fileEntries),
            category: Number(category),
            partnerId: selectedPartner,
            notes: notes,
            signatoryDesignation: signatoryDesignation,
            signatoryName: signatoryName,
            refundPocs: emails,
            notifyDisbursements:  notifyDisbursements,
            notifyRefunds: notifyRefunds,
            notifyT3Reminders: notifyT3Reminders,
            notifyBounces: notifyBounces,
            instituteParentId: selectedParentInstitute ? selectedParentInstitute.id : "",
            fundSource: Number(fundSource)
          };

          if (category === "") {
            alert("Select Institute Category");
          } else {
            axiosInstance.post(`/institute/info/create`, obj2, {
              headers: {
              }
            })
              .then((resp) => {
                setEnableNext(true);
                alert("Institute Details added");
                setTimeout(() => window.location.reload(true), 2000);
              })
              .catch((err) => alert(err?.response?.data?.message));
          }
        });

      const newInstitute = {
        code: instituteCode,
        name: insName,
        email: insEmail,
        contact: number,
        address: insAddress,
        city: insCity,
        state: insState,
        gstApplicable: gstApplicableCheck,
        gstNumber: gstNumber,
        pincode: insPincode,
        salesOwner: 'string',
        website: 'string',
        mouFiles: JSON.stringify(fileEntries),
        notes: notes,
        signatoryDesignation: signatoryDesignation,
        signatoryName: signatoryName,
        notifyDisbursements:  notifyDisbursements,
        notifyRefunds: notifyRefunds,
        notifyT3Reminders: notifyT3Reminders,
        notifyBounces: notifyBounces,
        instituteParentId: selectedParentInstitute ? selectedParentInstitute.id : ""
      };
      onAddInstitute(newInstitute);
    } else {
      const obj2 = {
        code: instituteCode,
        name: insName,
        email: insEmail,
        contact: number,
        address: insAddress,
        city: insCity,
        state: insState,
        gstApplicable: gstApplicableCheck,
        gstNumber: gstNumber,
        pincode: insPincode,
        salesOwner: 'string',
        website: 'string',
        mouFiles: JSON.stringify(fileEntries),
        category: Number(category),
        partnerId: selectedPartner,
        signatoryDesignation: signatoryDesignation,
        notes: notes,
        signatoryName: signatoryName,
        refundPocs: emails,
        notifyDisbursements:  notifyDisbursements,
        notifyRefunds: notifyRefunds,
        notifyT3Reminders: notifyT3Reminders,
        notifyBounces: notifyBounces,
        instituteParentId: selectedParentInstitute ? selectedParentInstitute.id : "",
        fundSource: Number(fundSource)
      };

      if (category === "") {
        alert("Select Institute Category");
      } else {
        axiosInstance.post(`/institute/info/create`, obj2, {
          headers: {
          }
        })
          .then((resp) => {
            setEnableNext(true);
            alert("Institute Details added");
            setTimeout(() => window.location.reload(true), 2000);
          })
          .catch((err) => alert('Error ! Check Fields'));
      }

      const newInstitute = {
        code: instituteCode,
        name: insName,
        email: insEmail,
        contact: number,
        address: insAddress,
        city: insCity,
        state: insState,
        gstApplicable: gstApplicableCheck,
        gstNumber: gstNumber,
        pincode: insPincode,
        salesOwner: 'string',
        website: 'string',
        mouFiles: JSON.stringify(fileEntries),
        signatoryDesignation: signatoryDesignation,
        signatoryName: signatoryName,
        notes: notes,
        notifyDisbursements:  notifyDisbursements,
        notifyRefunds: notifyRefunds,
        notifyT3Reminders: notifyT3Reminders,
        notifyBounces: notifyBounces,
        instituteParentId: selectedParentInstitute ? selectedParentInstitute.id : ""
      };
      onAddInstitute(newInstitute);
    }
  };

  const popUpForm = () => {
    setFormOpen(true);
    axiosInstance.get(`/channel-partners/get-partners`)
      .then((res) => {
        setPartners(res?.data?.data);
      }).catch((err) => err);
  };

  const getS3FileUrl = async (newFile) => {
    const file = new FormData();
    file.append('file', newFile);
    file.append('type', "MOU");
    try {
      const response = await axiosInstance.post(`/file/upload`, file);
      const s3Url = await response.data.data.s3Url;
      return s3Url;
    } catch (error) {
      alert(`${error}, Please Reupload MOU`);
    }
  };

  const handleFileNameChange = (index, value) => {
    setFileEntries((prevEntries) =>
      prevEntries.map((entry, i) =>
        i === index ? { ...entry, fileName: value } : entry
      )
    );
  };

  const handleAddMoreFiles = () => {
    setFileEntries([...fileEntries, { fileName: '', file: null, url: null }]);
  };

  const handleRemoveFiles = (index) => {
    setFileEntries((prevEntries) => prevEntries.filter((_, i) => i !== index));
  };

  const handleFileChange = async (index, file) => {
    const url = await getS3FileUrl(file);
    setFileEntries((prevEntries) =>
      prevEntries.map((entry, i) =>
        i === index ? { ...entry, file, url } : entry
      )
    );
  };

  const handleClearFile = () => {
    setFileEntries([{ fileName: '', file: null, url: null }]);
  };

  const handlePartnerChange = (e) => {
    setSelectedPartner(e.target.value);
  };

  return (
    <>
     <p style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'500', textTransform: 'capitalize',cursor:'pointer',width:'150px',height:'34px',fontFamily:'Inter-Medium',fontSize:'16px',backgroundColor:'#D22129',display:'flex',alignItems:'center',justifyContent:'center',color:'white',borderRadius:'6px'}} onClick={() => popUpForm()}><img src={plus} style={{marginRight:'10px'}}/>Add Institute</p>

      {formOpen && (
        <Modal
          isOpen={formOpen}
          toggle={() => setFormOpen(!formOpen)}
          size="xl"
          style={{ maxWidth: '1400px' }}
        >
          <ModalBody style={{ padding: '30px' }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '25px',
              borderBottom: '2px solid #f0f0f0',
              paddingBottom: '15px'
            }}>
              <h4 style={{ margin: 0, fontWeight: '600' }}>Add Institute</h4>
              <img
                onClick={() => setFormOpen(!formOpen)}
                src={close}
                alt="close"
                style={{ cursor: 'pointer', width: '24px', height: '24px' }}
              />
            </div>

            <Form>
              {/* Row 1: Institute Code, Name, Email, Contact */}
              <Row className="mb-3">
                <Col md={3}>
                  <FormGroup>
                    <Label for="instituteCode">Institute Code</Label>
                    <Input
                      id="instituteCode"
                      name="instituteCode"
                      placeholder="3 letter institute code"
                      type="text"
                      value={instituteCode}
                      onChange={(e) => setInstituteCode(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="instituteName">Institute Name<span style={{ color: 'red' }}>*</span></Label>
                    <Input
                      id="instituteName"
                      name="instituteName"
                      placeholder="Institute Name Here"
                      type="text"
                      value={insName}
                      onChange={(e) => setInstituteName(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="email">Email Address<span style={{ color: 'red' }}>*</span></Label>
                    <Input
                      id="email"
                      name="email"
                      placeholder="Email address Here"
                      type="email"
                      value={insEmail}
                      onChange={(e) => setInstituteEmail(e.target.value)}
                    />
                    <FormText>We'll never share your email with anyone else.</FormText>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="contact">Contact<span style={{ color: 'red' }}>*</span></Label>
                    <Input
                      id="contact"
                      name="contact"
                      placeholder="Institute Contact here"
                      type="text"
                      value={number}
                      onChange={(e) => setInstituteNumber(e.target.value)}
                    />
                  </FormGroup>
                </Col>
              </Row>

              {/* Row 2: City, State, Pincode, Address */}
              <Row className="mb-3">
                <Col md={3}>
                  <FormGroup>
                    <Label for="city">City</Label>
                    <Input
                      id="city"
                      name="city"
                      placeholder="City"
                      type="text"
                      value={insCity}
                      onChange={(e) => setInstituteCity(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="state">State</Label>
                    <Input
                      id="state"
                      name="state"
                      placeholder="State"
                      type="text"
                      value={insState}
                      onChange={(e) => setInstituteState(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="pincode">Pincode</Label>
                    <Input
                      id="pincode"
                      name="pincode"
                      placeholder="Pincode"
                      type="text"
                      value={insPincode}
                      onChange={(e) => setInstitutePincode(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="address">Address<span style={{ color: 'red' }}>*</span></Label>
                    <Input
                      id="address"
                      name="address"
                      placeholder="Institute Address"
                      type="textarea"
                      value={insAddress}
                      onChange={(e) => setInstituteAddress(e.target.value)}
                      style={{ minHeight: '38px' }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              {/* Row 3: Institute Type, Category, Partner, Logo */}
              <Row className="mb-3">
                <Col md={3}>
                  <FormGroup>
                    <Label for="instituteType">Institute Type</Label>
                    <Input
                      id="instituteType"
                      name="instituteType"
                      type="select"
                      value={insType}
                      onChange={(e) => setInstituteType(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Education Trust">Education Trust</option>
                      <option value="Education Society">Education Society</option>
                      <option value="Private Limited">Private Limited</option>
                      <option value="Limited Liability Partnership">Limited Liability Partnership</option>
                      <option value="Firm">Firm</option>
                      <option value="Proprietorship">Proprietorship</option>
                      <option value="Others">Others</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="category">Institute Category</Label>
                    <Input
                      id="category"
                      name="category"
                      type="select"
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="1">K-12</option>
                      <option value="2">College</option>
                      <option value="3">UpSkilling</option>
                      <option value="4">Exec Ed</option>
                      <option value="5">Other</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="partner">Institute Partner</Label>
                    <Input
                      id="partner"
                      name="partner"
                      type="select"
                      value={selectedPartner}
                      onChange={handlePartnerChange}
                    >
                      <option value="">Select</option>
                      {partners.map((item) => (
                       <option key={item.partnerId} value={item.partnerId}>
                        {item.name}
                      </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="logo">Logo</Label>
                    <Input
                      id="logo"
                      name="logo"
                      type="file"
                      onChange={(e) => setInstituteLogo(e.target.files[0])}
                    />
                  </FormGroup>
                </Col>
              </Row>

              {/* Combined Row: GST, Notify, Refund POCs, Same as Institute */}
              <Row className="mb-3" style={{ alignItems: 'center' }}>
                <Col md={6}>
                <div style={{display:'flex'}}>
                  <FormGroup check style={{ marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                    <Label check style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                      <Input
                        type="checkbox"
                        checked={gstApplicableCheck}
                        onChange={(e) => setGSTApplicableCheck(e.target.checked)}
                        style={{ marginTop: 0, marginRight: '8px' }}
                      />
                      GST Applicable
                    </Label>
                  </FormGroup>
                    {gstApplicableCheck && (
                <Row >
                  <Col md={12}>
                    <Input
                      placeholder="GST Number"
                      value={gstNumber}
                      onChange={(e) => setGSTNumber(e.target.value)}
                      type="text"
                      style={{ maxWidth: '300px', marginLeft: '20px' }}
                    />
                  </Col>
                </Row>
              )}
</div>
                </Col>
               
                <Col md={6}>
                <div style={{display:'flex'}}>
                  <FormGroup style={{ marginBottom: 0 }}>
                    <Label style={{ marginBottom: '5px', fontSize: '14px' }}>Select Parent (Same as Institute)</Label>
                    <div style={{ display: 'flex', gap: '20px' }}>
                      <FormGroup check inline style={{ marginBottom: 0 }}>
                        <Label check style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                          <Input
                            type="radio"
                            name="sameAsInstitute"
                            checked={isSameAsInstitute}
                            onChange={() => {
                              setIsSameAsInstitute(true);
                              setSelectedParentInstitute(null);
                              setParentSearch('');
                            }}
                            style={{ marginTop: 0, marginRight: '5px' }}
                          />
                          Yes
                        </Label>
                      </FormGroup>
                      <FormGroup check inline style={{ marginBottom: 0 }}>
                        <Label check style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                          <Input
                            type="radio"
                            name="sameAsInstitute"
                            checked={!isSameAsInstitute}
                            onChange={() => setIsSameAsInstitute(false)}
                            style={{ marginTop: 0, marginRight: '5px' }}
                          />
                          No
                        </Label>
                      </FormGroup>
                    </div>
                  </FormGroup>
                   {!isSameAsInstitute && (
                <Row className="mb-3">
                  <Col md={12} style={{marginLeft:'20px'}}>
                    <FormGroup style={{ position: 'relative' }}>
                      <Label for="parentInstitute">Select Parent Institute</Label>
                      <Input
                        id="parentInstitute"
                        placeholder="Type parent institute name"
                        value={parentSearch}
                        onChange={(e) => {
                          setParentSearch(e.target.value);
                          searchParentInstitute(e.target.value);
                        }}
                        style={{ maxWidth: '400px' }}
                      />
                      {parentResults.length > 0 && (
                        <div style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          backgroundColor: 'white',
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          maxWidth: '400px',
                          maxHeight: '200px',
                          overflowY: 'auto',
                          zIndex: 1000,
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          {parentResults.map((item) => (
                            <div
                              key={item.id}
                              onClick={() => {
                                setSelectedParentInstitute(item);
                                setParentSearch(item.name);
                                setParentResults([]);
                              }}
                              style={{
                                padding: '10px',
                                cursor: 'pointer',
                                borderBottom: '1px solid #f0f0f0'
                              }}
                              onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                              onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                            >
                              {item.name}
                            </div>
                          ))}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              )}
              </div>
                </Col>
               
              </Row>
              <Row className='mt-3'>
                <Col md={3}>
                  <FormGroup check style={{ marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                    <Label check style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                      <Input
                        type="checkbox"
                        checked={notifyDisbursements}
                        onChange={(e) => setNotifyDisbursements(e.target.checked)}
                        style={{ marginTop: 0, marginRight: '8px' }}
                      />
                      Notify Disbursements
                    </Label>
                  </FormGroup>
                </Col>
                 <Col md={3}>
                  <FormGroup check style={{ marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                    <Label check style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                      <Input
                        type="checkbox"
                        checked={notifyRefunds}
                        onChange={(e) => setNotifyRefunds(e.target.checked)}
                        style={{ marginTop: 0, marginRight: '8px' }}
                      />
                      Notify Refunds
                    </Label>
                  </FormGroup>
                </Col>
                 <Col md={3}>
                  <FormGroup check style={{ marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                    <Label check style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                      <Input
                        type="checkbox"
                        checked={notifyT3Reminders}
                        onChange={(e) => setNotifyT3Reminders(e.target.checked)}
                        style={{ marginTop: 0, marginRight: '8px' }}
                      />
                      Notify T-3 Reminders
                    </Label>
                  </FormGroup>
                </Col>
                 <Col md={3}>
                  <FormGroup check style={{ marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                    <Label check style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                      <Input
                        type="checkbox"
                        checked={notifyBounces}
                        onChange={(e) => setNotifyBounces(e.target.checked)}
                        style={{ marginTop: 0, marginRight: '8px' }}
                      />
                      Notify Bounces
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              {/* GST Number Row - Shows when GST is checked */}
            
              {/* Select Parent Institute Row - Shows when "No" is selected */}
             

              {/* Row: Signatory Designation, Name, Policy, Fund Source */}
              <Row className="mb-3 mt-5">
                <Col md={3}>
                  <FormGroup>
                    <Label for="signatoryDesignation">Signatory Designation<span style={{ color: 'red' }}>*</span></Label>
                    <Input
                      id="signatoryDesignation"
                      name="signatoryDesignation"
                      placeholder="signatoryDesignation"
                      type="text"
                      value={signatoryDesignation}
                      onChange={(e) => setSignatoryDesignation(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="signatoryName">Signatory Name<span style={{ color: 'red' }}>*</span></Label>
                    <Input
                      id="signatoryName"
                      name="signatoryName"
                      placeholder="signatoryName"
                      type="text"
                      value={signatoryName}
                      onChange={(e) => setSignatoryName(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="policy">Policy<span style={{ color: 'red' }}>*</span></Label>
                    <Input
                      id="policy"
                      name="policy"
                      placeholder="Policy"
                      type="textarea"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      style={{ minHeight: '38px' }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="fundSource">Fund Source</Label>
                    <Input
                      id="fundSource"
                      name="fundSource"
                      type="select"
                      value={fundSource}
                      onChange={(e) => setFundSource(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="1">GBP</option>
                      <option value="2">FIB</option>
                      <option value="3">Manual</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              {/* MOU Section */}
              <Row className="mb-3">
                <Col md={6}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    marginBottom: '10px'
                  }}>
                    <Label style={{ marginBottom: 0, fontWeight: '600' }}>MOU  <Button
                      size="sm"
                      color="link"
                      onClick={handleClearFile}
                      style={{ padding: '0', fontSize: '12px',marginLeft:'20px' }}
                    >
                      Clear All
                    </Button></Label>
                   
                  </div>

                  {fileEntries?.map((entry, index) => (
                    <div key={index} style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '10px',
                      marginBottom: '10px'
                    }}>
                      <Input
                        placeholder="Enter File Name"
                        value={entry.fileName}
                        onChange={(e) => handleFileNameChange(index, e.target.value)}
                        style={{ maxWidth: '230px' }}
                      />
                      <Input
                        type="file"
                        onChange={(e) => handleFileChange(index, e.target.files[0])}
                        style={{ maxWidth: '300px' }}
                      />
                      {index !== 0 && (
                        <RemoveCircleOutlineIcon
                          onClick={() => handleRemoveFiles(index)}
                          fontSize="small"
                          style={{ cursor: 'pointer', color: '#dc3545' }}
                        />
                      )}
                      {index === fileEntries.length - 1 && (
                        <AddCircleIcon
                          onClick={handleAddMoreFiles}
                          fontSize="small"
                          style={{ cursor: 'pointer', color: '#28a745' }}
                        />
                      )}
                    </div>
                  ))}
                </Col>
                 <Col md={6}>
                  <FormGroup style={{ marginBottom: 0 }}>
                    <Label style={{ marginBottom: '5px', fontSize: '14px' }}>Refund POCs (Emails)</Label>
                    <div style={{ 
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '6px 8px',
                      minHeight: '38px',
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '5px',
                      alignItems: 'center'
                    }}>
                      {emails.map((email, index) => (
                        <span
                          key={index}
                          style={{
                            backgroundColor: '#e9ecef',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '5px',
                            fontSize: '13px'
                          }}
                        >
                          {email}
                          <span
                            onClick={() => setEmails(emails.filter((_, i) => i !== index))}
                            style={{
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              color: '#6c757d'
                            }}
                          >
                            ×
                          </span>
                        </span>
                      ))}
                      <Input
                        type="text"
                        placeholder="Type email and press Enter"
                        value={currentEmail}
                        onChange={(e) => setCurrentEmail(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && currentEmail.trim()) {
                            setEmails([...emails, currentEmail.trim()]);
                            setCurrentEmail('');
                            e.preventDefault();
                          }
                        }}
                        style={{
                          border: 'none',
                          outline: 'none',
                          flex: 1,
                          minWidth: '150px',
                          padding: '2px 4px',
                          fontSize: '14px'
                        }}
                      />
                    </div>
                  </FormGroup>
                </Col>

              </Row>

              {/* Submit Button */}
               <Button style={{marginLeft:'40%',width:'10em',backgroundColor:'#D32028',border:'none'}}
                        onClick={() => callRegistration()}
                        color="primary"
                      >
                     <span style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'500', textTransform: 'capitalize',color:'white'}}>Save Details</span>
                      </Button>
            </Form>
          </ModalBody>
        </Modal>
      )}
    </>
  );
}